window.chmSelect = (function() {
    var _this;

    _this = function(options) {
        var $content, $items, $search, $reset, dialog;

        function applySearch(text) {
            let words;

            words = String(text).trim().split(' ').filter(word => word !== '');

            if (words.length === 0) {
                resetSearch();
                return;
            }

            $items.find('.dialog-select-items-item:not(.separator):not([data-value=""])').each(function() {
                let $item, itemText, isMatch;

                $item = $(this);
                itemText = String($item.text()).toLowerCase();
                isMatch = true;

                words.forEach(word => {
                    if (itemText.indexOf(word.toLowerCase()) === -1) {
                        isMatch = false;
                    }
                });

                $item.css('display', isMatch ? '' : 'none');

                if (!isMatch) {
                    $item.removeClass('selected');
                }
            });

            $reset.show();

            toggleButtons();
        }

        function resetSearch() {
            $search.find('input').val('');
            $items.children().show();
            $reset.hide();
            toggleButtons();

            if (!dialog) {
                return;
            }

            dialog.scrollToTop(true);
        }

        function toggleButtons() {
            let hasSelection;
            
            if (!dialog) {
                return;
            }

            hasSelection = ($items.find('.dialog-select-items-item.selected').length > 0);

            dialog.$buttons.find('.button[data-button-type="primary"]').toggleClass('isDisabled', !hasSelection);
        }

        function focusSelectedItem() {
            let $selectedItem;

            if (!dialog) {
                return;
            }

            $selectedItem = $items.find('.dialog-select-items-item.selected').first();

            if ($selectedItem.length > 0) {
                AnimationHandler.scrollIntoView($selectedItem, true, true);
            }
        }

        $content = $('<div>').addClass('dialog-select');

        $items = $('<div>').addClass('dialog-select-items');

        if (options.isSearchable) {
            $search = $('<div>').addClass('dialog-select-search').append(
                $('<div>').addClass('dialog-select-search-field').append(
                    '<i class="fa-solid fa-magnifying-glass"></i>',
                    $(`<input type="text" placeholder="${__i18n('button/filterList')}...">`).on('input change', function() {
                        applySearch(this.value);
                    }),
                    $('<i class="fa-solid fa-delete-left"></i>').on('click', function() {
                        resetSearch();
                    })
                )
            );
        }

        $content.append($items);

        options.items.forEach(function(item) {
            if (item.isSeparator) {
                $items.append(
                    $('<div>')
                        .addClass('dialog-select-items-item separator')
                        .attr('data-optgroup-id', item.optgroupId || '')
                        .append(item.html)
                );

                return;
            }

            $items.append(
                $('<div>')
                    .addClass('dialog-select-items-item')
                    .attr('data-optgroup-id', item.optgroupId || '')
                    .toggleClass('selected', !!item.isSelected)
                    .toggleClass('disabled', !!item.isDisabled)
                    .toggleClass('grouped', !!item.isGrouped)
                    .attr('data-value', item.value).attr(item.attr || {})
                    .append(item.html)
                    .on('click', function() {
                        let wasSelected, $emptyItems, hasEmptyItem;

                        wasSelected = this.classList.contains('selected');

                        $items.children().removeClass('selected');
                        $emptyItems = $items.children(`[data-value=""]`);

                        hasEmptyItem = ($emptyItems.length > 0);

                        if (wasSelected && hasEmptyItem) {
                            $emptyItems.addClass('selected');
                        } else {
                            $items.children(`[data-value="${item.value}"]`).addClass('selected');
                        }

                        toggleButtons();
                    })
            );
        });

        if (options.isSearchable) {
            $reset = $('<div>').addClass(`dialog-select-items-reset`).append(
                '<i class="fa-solid fa-delete-left"></i>',
                $('<span>').text(__i18n('button/resetFilter'))
            ).on('click', function() {
                resetSearch();
            });
            $items.append($reset.hide());
        }

        dialog = chmDialog({
            title: $('<div>').append(
                $('<div>').html(options.title || __i18n('form/select')),
                options.isSearchable ? $search : null
            ),
            content: $content,
            typeToFocus: options.isSearchable ? $search.find('input') : null,
            fixedHeight: true,
            paddingTop: false,
            paddingBottom: false,
            buttons: [
                {
                    label: __i18n('button/select'),
                    primary: true,
                    action: function() {
                        let $selectedItem;
                        $selectedItem = $items.find('.dialog-select-items-item.selected');

                        if ($selectedItem.length == 0) {
                            return false;
                        }

                        ScoreTrekBattle.Event.callFunction(options.onSelect, $selectedItem.attr('data-value'), $selectedItem);
                    }
                },
                {
                    label: __i18n('button/cancel'),
                    action: function() {
                    }
                }
            ],
            onShow: function() {
                toggleButtons();
                focusSelectedItem();
            }
        });

        // Der Dialog wird zurueckgegeben, damit ein Aufrufer sich an sein
        // Schliessen haengen kann — noetig, wenn die Wahl selbst wieder einen
        // Dialog oeffnet.
        return dialog;
    };

    _this.fromControl = function(control) {
        let $select, $label, items, currentOptgroupLabel, optgroupId, selectedValue;

        $select = control.$view.find('select');
        $label = control.$view.find('.select-label');

        items = [];

        currentOptgroupLabel = '';
        optgroupId = 0;

        selectedValue = control.get();

        $select.find('option').each(function() {
            var $option, $optgroup, hasOptgroup, optgroupLabel, value, indent;
            $option = $(this);

            $optgroup = $option.closest('optgroup');

            hasOptgroup = ($optgroup.length > 0);

            optgroupLabel = hasOptgroup ? $optgroup.attr('label') : '';

            if (hasOptgroup && (optgroupLabel != currentOptgroupLabel)) {
                currentOptgroupLabel = optgroupLabel;
                optgroupId++;
                items.push({
                    html: $optgroup.attr('data-html') || `${currentOptgroupLabel}`,
                    isSeparator: true,
                    optgroupId: `optgroup_${optgroupId}`
                });
            }

            value = $option.attr('value');
            indent = $option.attr('data-indent') || '';

            items.push({
                value: value,
                html: $option.html(),
                isSelected: (value === selectedValue),
                isDisabled: $option.prop('disabled'),
                isGrouped: hasOptgroup,
                optgroupId: hasOptgroup ? `optgroup_${optgroupId}` : '',
                attr: (indent === '') ? null : {'data-indent': indent}
            });
        });


        _this({
            title: $label.text(),
            isSearchable: (control.$view.attr('data-is-searchable') !== 'no'),
            items: items,
            onSelect: function(value, $selectedItem) {
                let selectAction, select;

                control.set(value).trigger('change');

                selectAction = $select.attr('data-select-action');

                if (selectAction && (selectAction != '')) {
                    select = $select.get(0);
                    ScoreTrekBattle.Events.trigger(`action.${selectAction}`, select, [select.dataset.hasOwnProperty('actionArguments') ? String(select.dataset.actionArguments) : '']);
                }
            }
        });
    };

    _this.addItem = function($select, value, text, fullText) {
        $select.append($('<option>').attr({
            'value': value,
            'data-text': text
        }).html(fullText));        
    };

    return _this;
})();